import { render, staticRenderFns } from "./TransactionDetailPage.vue?vue&type=template&id=6f59403a&scoped=true&"
import script from "./TransactionDetailPage.vue?vue&type=script&lang=ts&"
export * from "./TransactionDetailPage.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionDetailPage.vue?vue&type=style&index=0&id=6f59403a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f59403a",
  null
  
)

export default component.exports